<div class="ejdf-container">
  <div *ngIf="isLoading"></div>
  <div *ngIf="(request$ | async) as request">
    <div class="ejdfHeader">
      <kendo-gridlayout [rows]="[{height: 75}]" class="sticky-header">
        <kendo-gridlayout-item [row]="1" [colSpan]="2">
          <!-- On-Hold and Priority Indicators -->
          <div class="header-indicators">
            <span *ngIf="request.onHold" class="on-hold-badge" title="Order is on hold">
              <span class="k-icon k-font-icon k-i-hand"></span> ON HOLD
            </span>
            <span *ngIf="isHighPriority(request)" class="priority-badge" title="High Priority">
              <span class="k-icon k-font-icon k-i-warning"></span> HIGH PRIORITY
            </span>
          </div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="2" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Request Id</div>
          <div kendoTypography themeColor="error" variant="h4" style="margin: 0px; color: #F31700; font-size: 22px;">
            {{id}}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="2" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Service #</div>
          <div kendoTypography themeColor="error" variant="h4" class="copyable-value"
            style="margin: 0px; color: #F31700; font-size: 22px;"
            (click)="copyToClipboard(getServiceNumber(request), 'Service Number')" title="Click to copy">
            {{ getServiceNumber(request) }}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="2" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Material #</div>
          <div kendoTypography themeColor="error" variant="h4" class="copyable-value"
            style="margin: 0px; color: #F31700; font-size: 22px;"
            (click)="copyToClipboard(getMaterialNumber(request), 'Material Number')" title="Click to copy">
            {{ getMaterialNumber(request) }}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="1" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Size</div>
          <div kendoTypography themeColor="error" variant="h4" style="margin: 0px; color: #F31700; font-size: 22px;">
            {{request.bit?.size}}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="3" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Nomenclature</div>
          <div kendoTypography themeColor="error" variant="h4" style="margin: 0px; color: #F31700; font-size: 22px;">
            {{request?.bit?.type}}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="2" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Cutter Type</div>
          <div kendoTypography themeColor="error" variant="h4" class="copyable-value"
            style="margin: 0px; color: #F31700; font-size: 22px;"
            (click)="copyToClipboard(currentCutterType, 'Cutter Type')" title="Click to copy">
            {{ (cutterType$ | async) ?? 'Pending' }}
          </div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="4" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Request Status</div>
          <div kendoTypography themeColor="error" variant="h4" style="margin: 0px; color: #F31700; font-size: 22px;">
            {{request.process?.name??''}}</div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [colSpan]="2" style="text-align: center;">
          <div kendoTypography variant="p" style="margin: 0px;">Bit Level</div>
          <div kendoTypography themeColor="error" variant="h4" style="margin: 0px; color: #F31700; font-size: 22px;">
            {{request?.bit?.level}}</div>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </div>
    <div class="container">
      <kendo-tabstrip>
        <kendo-tabstrip-tab title="Request Details" [selected]="true">
          <ng-template kendoTabContent>
            <div class="ejdf-tab-content">
              <kendo-pdf-export #pdf paperSize="A4" margin="2cm">
                <app-reviewrequest-data [draftId]="id" [Request]="request"
                  [cutterMappingInitial]="request.orD_CutterMap || []" [isEjdf]="true"></app-reviewrequest-data>
              </kendo-pdf-export>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="Cutters">
          <ng-template kendoTabContent>
            <div class="ejdf-tab-content">
              <app-cuttermapping-data [cutterMappingInitial]="request.orD_CutterMap || []"
                [retrofit]="request.requestExclusion||false" [isEJDF]="true" [draftId]="id"></app-cuttermapping-data>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="Files">
          <ng-template kendoTabContent>
            <div class="ejdf-tab-content">
              <div style="margin-bottom: 15px;">
                <fv-file-upload [targetId]="id || 0" [applicationTypeId]="2" [autoCreateDocument]="true"
                  (uploadCompleted)="onUploadCompleted($event)"></fv-file-upload>
              </div>
              <div>
                <fv-file-list [initialCriteria]="{ targetId: id, includeSubdirectories: true }" [targetId]="id || 0"
                  [applicationTypeId]="2" [visibleApplicationTypeNames]="['Rta']" [showToolbar]="false"
                  [showCheckout]="false" [refreshToken]="fileListRefreshToken"></fv-file-list>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="BOM">
          <ng-template kendoTabContent>
            <div class="ejdf-tab-content">
              <app-bom-data [materialNumber]="getMaterialNumber(request)"></app-bom-data>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="Populate SAP Data">
          <ng-template kendoTabContent>
            <div class="ejdf-tab-content"><app-populatesap-data [draftId]="id"
                [request$]="request$"></app-populatesap-data>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="Processes">
          <ng-template kendoTabContent>
            <app-processtask-data [draftId]="id"></app-processtask-data>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
      @if (viewChat) {
      <kendo-window [resizable]="false" [(left)]="windowLeft" [minWidth]="300" [minHeight]="500"
        title="RTA/EJDF Communications" [keepContent]="true" autoFocusedElement="#messageBoxInput"
        (close)="viewChat=false">
        <app-communication-data [_initialcommunications]="request.communication"
          [draftId]="id"></app-communication-data>
      </kendo-window>}

    </div>
  </div>

  <!-- Request Drawing Number Dialog -->
  <kendo-dialog *ngIf="showDrawingDialog" title="Request Drawing Number" [minWidth]="400" [width]="500"
    (close)="closeDrawingDialog()">
    <div class="drawing-dialog-content">
      <p class="dialog-description">
        Request a new drawing number for Request #{{ id }}. The drawing will be associated with this request.
      </p>
      <fv-drawing-number-request [rtaNum]="id" [createdBy]="currentUserId" [subPsl]="(request$ | async)?.subPsl"
        [productLine]="'Matrix'" [partNumber]="materialNumber">
      </fv-drawing-number-request>
    </div>

    <kendo-dialog-actions>
      <button kendoButton look="outline" (click)="closeDrawingDialog()" [disabled]="drawingSubmitting">
        Cancel
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-floatingactionbutton themeColor="tertiary" [svgIcon]="GearsSVG" [positionMode]="'fixed'"
    (dialItemClick)="onDialItemClick($event)" [dialItems]="actionItems">
  </kendo-floatingactionbutton>
</div>